import { render, staticRenderFns } from "./CandidateInterviewsIndex.vue?vue&type=template&id=b1649298&scoped=true"
import script from "./CandidateInterviewsIndex.vue?vue&type=script&lang=ts"
export * from "./CandidateInterviewsIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1649298",
  null
  
)

export default component.exports